import { useEffect, useState } from 'react';
import { UploadServices } from 'store';
import { Loader } from '../../loader';

export const VideoPlayer = ({ videoKey }) => {
    const [videoUrl, setVideoUrl] = useState('');
    const [load, setLoad] = useState(false);

    useEffect(() => {
        const fetchVideoUrl = async () => {
            if (!videoKey) return;
            setLoad(true);
            try {
                const response = await UploadServices.VideoUrl(videoKey);
                setVideoUrl(response?.data?.url);
            } catch (err) {
                console.error('Failed to fetch video URL', err);
            } finally {
                setLoad(false);
            }
        };

        fetchVideoUrl();
    }, [videoKey]);

    return (
        <div style={{ width: 990, maxWidth: '100%', height: 557 }}>
            {load ? (
                <Loader height={560} />
            ) : (
                videoUrl && (
                    <video
                        src={videoUrl}
                        width="100%"
                        height="100%"
                        controls
                        controlsList="nodownload"
                    />
                )
            )}
        </div>
    );
};
